export default __webpack_public_path__ + "831efc2b37c6c57a1f080862edddf742.woff";